const AvisoSchema = () => ({
  title: 'AgSUS Aviso',
  fieldsets: [{ id: 'default', title: 'Conteúdo', fields: ['tipo', 'rotulo'] }],
  properties: {
    tipo: {
      title: 'Tipo',
      description:
        'Muda a cor e o ícone: Atenção (amarelo), Prazo (vermelho), Importante (verde), Nota (azul).',
      choices: [
        ['atencao', 'Atenção'],
        ['prazo', 'Prazo'],
        ['importante', 'Importante'],
        ['nota', 'Nota'],
      ],
      default: 'nota',
    },
    rotulo: {
      title: 'Rótulo',
      description:
        'Texto da etiqueta. Vazio: o nome do tipo. Ex.: Situação atual',
    },
  },
  required: [],
});

export default AvisoSchema;
